import { InjectionToken } from '@angular/core';
import { OverlaysService } from './overlays.service';

export { OverlayRef } from './overlay-ref.model';
export { OverlaysService };

export interface PositionTarget {
    getBoundingClientRect(): DOMRect;
}

export const POSITION_TARGET = new InjectionToken<PositionTarget>('PositionTarget');
